const defaultPPEs = [];

export default defaultPPEs;
